/** Who can read a wiki page (its frontmatter `visibility`). */
export type PageVisibility = "private" | "members" | "org";

const VISIBILITIES: readonly PageVisibility[] = ["private", "members", "org"];
const FRONTMATTER = /^---\r?\n([\s\S]*?)\r?\n---(\r?\n|$)/;
const VISIBILITY_LINE = /^visibility:[^\n]*$/m;

/** The page's visibility as the indexer reads it: missing or unknown is `private`. */
export function visibilityOf(content: string): PageVisibility {
  const fm = FRONTMATTER.exec(content)?.[1] ?? "";
  const raw = VISIBILITY_LINE.exec(fm)?.[0]
    .slice("visibility:".length)
    .trim()
    .replace(/^["']|["']$/g, "")
    .toLowerCase();
  return VISIBILITIES.find((v) => v === raw) ?? "private";
}

/** The content with its frontmatter `visibility` set (added, or a frontmatter block created). */
export function withVisibility(content: string, visibility: PageVisibility): string {
  const match = FRONTMATTER.exec(content);
  if (!match) return `---\nvisibility: ${visibility}\n---\n${content}`;
  const fm = match[1];
  const next = VISIBILITY_LINE.test(fm)
    ? fm.replace(VISIBILITY_LINE, `visibility: ${visibility}`)
    : `${fm}\nvisibility: ${visibility}`;
  return content.replace(FRONTMATTER, `---\n${next}\n---${match[2]}`);
}
